import Toast from "@/components/ui-kit/toast"
import useToasts from "@/library/toasts/_hook.toast"
import {AnimatePresence, motion} from "framer-motion"
import {classNames} from "@/library/utilities/html"

type ToastsListProps = {
    category?: string
    position?: "bottom-right" | "inline"
}

export default function ToastsList(
    {
        category,
        position = "inline"
    }: ToastsListProps
) {
    const {toasts, closeToast} = useToasts()

    //const toastsToRender: ToastProps[] = []

    //useEffect(() => {
    //    //const filtered: ToastProps[] =  as ToastProps[]

    //    //toastsToRender.push(...filtered)
    //}, [toasts])

    //console.log(Object.entries(toasts))

    if (Object.values(toasts).filter(toast => !toast.removed).length == 0)
        return <></>

    return <motion.div className={classNames(
        "toasts-container",
        `position-${position}`
    )} layout="position" transition={{
        layout: {
            //duration: .5
        }
    }}>
        {Object.entries(toasts)
            //.filter(([_, props]) => props != undefined)
            .map(([_, props]) => props)
            .filter(props => {
                if (!category)
                    return true

                return props?.category == category
            }).map((toast, index) => {

                return <AnimatePresence key={`toast-${index}`} mode="sync">
                    {!toast.removed && <motion.div
                        drag="x"
                        dragConstraints={{
                            left: 0,
                            right: 0
                        }}
                        //dragElastic={0.5}
                        dragMomentum={false}
                        onDragEnd={() => {
                            closeToast(toast.refKey)
                        }}
                        initial={{
                            opacity: 0,
                            //x: 50,
                            y: 50,
                            //scale: 0.5
                        }}
                        animate={{
                            opacity: 1,
                            x: 0,
                            y: 0,
                            scale: 1,
                            transition: {
                                //duration: 0.2,
                                delay: 0.08 * index
                            }
                        }}
                        exit={{
                            opacity: 0,
                            x: 200,
                            //scale: 0.5
                        }}
                    ><Toast {...toast} /></motion.div>}
                </AnimatePresence>
            })}
    </motion.div>
}
